/**
 * Validation Utilities - Shared validation functions
 *
 * SYNC: This module is shared between frontend and backend.
 */

/**
 * Validate email address format
 * Uses a more comprehensive validation following RFC 5322 simplified
 * @param {string} email - Email address to validate
 * @returns {boolean} Whether email is valid
 */
export function isValidEmail(email) {
    if (!email || typeof email !== 'string') return false;

    // Normalize: trim and lowercase
    const normalized = email.trim().toLowerCase();

    // Length checks (per RFC 5321)
    if (normalized.length < 5 || normalized.length > 254) return false;

    // More comprehensive regex (RFC 5322 simplified)
    // Allows: letters, numbers, dots, hyphens, underscores, plus signs in local part
    // Requires: valid domain structure with at least 2-char TLD
    const emailRegex = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)*\.[a-z]{2,}$/i;

    if (!emailRegex.test(normalized)) return false;

    // Additional checks
    const [localPart, domain] = normalized.split('@');

    // Local part max 64 characters (RFC 5321)
    if (localPart.length > 64) return false;

    // Domain max 253 characters
    if (domain.length > 253) return false;

    // Disallow consecutive dots
    if (normalized.includes('..')) return false;

    return true;
}

/**
 * Sanitize email for storage
 * Normalizes email address to consistent format
 * @param {string} email - Email address to sanitize
 * @returns {string} Sanitized email
 */
export function sanitizeEmail(email) {
    if (!email || typeof email !== 'string') return '';
    return email.trim().toLowerCase();
}
